import {Component, OnInit} from '@angular/core';
import {TrabalhoService} from "../trabalho/trabalho.service";
import {AcessoService} from "../acesso/acesso.service";
import {RecursoService} from "../pedir-recurso/recurso.service";
import {AppComponent} from "../app.component";
import {Trabalho} from "../trabalho/trabalho";
import {Usuario} from "../usuario/usuario";

@Component({
	selector: 'app-encaminhar-recurso',
	templateUrl: './encaminhar-recurso.component.html',
	styleUrls: ['./encaminhar-recurso.component.css'],
    providers: [TrabalhoService, AcessoService]
})
export class EncaminharRecursoComponent extends AppComponent implements OnInit {
	trabalhos: Trabalho[];
	usuarios_pareceristas: Usuario[];

	ngOnInit(): void {
		if (!(this.islogged() && this.isAdmin())) 
            this.router.navigateByUrl('acesso');
        else 
            this.getTrabalhos();    
    }
	
	getTrabalhos(): void {
		this.trabalhoService.getTrabalhos(true).then(trabalhos => {this.trabalhos = trabalhos; this.getUsersParecer();});
    }
	
	 getUsersParecer(): void {
        this.avaliacaoService.getparecerista().then(usuarios => this.usuarios_pareceristas = usuarios)
    }
	
	nome_parecerista(parecerista_id: number): string {
		let pareceristas: Usuario[] = this.usuarios_pareceristas;
		if (!pareceristas)
			return "";
		
		let i: number = pareceristas.length;
		while (--i >= 0)
			if (pareceristas[i].id == parecerista_id)
				return pareceristas[i].nome;
		return "";
	}

	save_recursista(trabalho: any): void {
		if (trabalho.parecerista_id == trabalho.recursista_id || trabalho.grupo == trabalho.recursista_id)
			this.utils.exibirMensagem('O avaliador do recurso não pode ser um dos avaliadores.', 'danger');
		else 
			this.recursoService.encaminharRecurso(trabalho.trabalho_id, trabalho.recursista_id);
	}
}



// WEBPACK FOOTER //
// ./src/app/encaminhar-recurso/encaminhar-recurso.component.ts